import { colors, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(
  (theme) => ({
    root: {
      background: theme.palette.common.white,
      height: "calc(100vh - 100px)",
      overflowX: "auto",
    },
    header: {
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      paddingTop: theme.spacing(3),
      fontWeight: theme.typography.fontWeightBold,
      color: theme.palette.secondary.main,
    },
    headerWrapper: {
      display: "flex",
      alignItems: "center",
    },
    counter: {
      fontSize: "1.2rem",
      fontWeight: 800,
    },
    errorWrapper: {
      marginTop: "20px",
      fontSize: "0.84rem",
      color: colors.red[800],
    },
    loadingWrapper: {
      display: "flex",
      alignItems: "center",
      paddingLeft: "4px",

      "& .caption": {
        color: theme.palette.grey[600],
        fontSize: "0.88rem",
      },
    },
    tableWrapper: {
      overflow: "hidden",

      "& table": {
        fontSize: 14,
        overflow: "hidden",
        // borderTop: "1px solid #e8e8e8",

        "& thead tr th:first-child": {
          padding: "14px 32px 14px 34px",
          textAlign: "left",
        },
        "& thead tr th": {
          padding: "14px 32px 14px 12px",
          textAlign: "left",
          borderBottom: "1px solid #e8e8e8",
        },
        "& thead tr th:last-child": {
          textAlign: "right",
        },
        "& tbody tr td:last-child": {
          textAlign: "right",
        },
        "& tbody tr td": {
          padding: "14px 32px 14px 12px",
          textAlign: "left",
          cursor: "pointer",
          borderBottom: "1px solid #e8e8e8",
        },
        "& tbody tr td:first-child": {
          padding: "14px 32px 14px 34px",
          fontWeight: 700,
        },
        "& tbody tr:hover": {
          "& td": {
            backgroundColor: theme.palette.grey[50],
          },
        },
        // "& tbody tr:nth-child(odd)": {
        //   "& td": {
        //     backgroundColor: theme.palette.common.white
        //   },
        // },
        // "& tbody tr:nth-child(even)": {
        //   "& td": {
        //     backgroundColor: "#fafafa",
        //   },
        // },
      },
    },
    extraAction: {
      marginRight: 4,
      color: colors.grey[800],
    },
    searchHeaderWrapper: {
      display: "flex",
      alignItems: "center",
      paddingLeft: "20px",
      paddingRight: theme.spacing(4),
    },
    searchWrapper: {
      display: "flex",
      alignItems: "center",

      "& input": {
        padding: "10px 12px",
        borderRadius: "10px !important",
      },
    },
    paginatorWrapper: {
      flexGrow: 1,
      display: "flex",
      alignItems: "center",
      marginTop: "14px",

      "& hr": {
        marginTop: "14px",
        height: "24px",
      },
    },
    actionItem: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginTop: "8px",

      "& button": {
        padding: "6px 12px",
      },

      "& .MuiSvgIcon-root": {
        marginBottom: "3px",
      },
    },
  }),
  {
    name: "activities-tab-styles",
    flip: null,
  }
);

export default useStyles;
